import { withBemMod } from '@bem-react/core';
import { cnTooltip } from '../Tooltip';
import './Tooltip_size_m.css';
/**
 * Модификатор, отвечающий за размер тултипа.
 * @param {TooltipSizeMProps} props
 */
export var withSizeM = withBemMod(cnTooltip(), { size: 'm' });
